/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    SlackChannel2,
    SlackChannel2FromJSON,
    SlackChannel2ToJSON,
} from './';

/**
 * 
 * @export
 * @interface SlackChannelsResponse
 */
export interface SlackChannelsResponse {
    /**
     * 
     * @type {Array<SlackChannel2>}
     * @memberof SlackChannelsResponse
     */
    channels: Array<SlackChannel2>;
}

export function SlackChannelsResponseFromJSON(json: any): SlackChannelsResponse {
    return {
        
        'channels': (json['channels'] as Array<any>).map(SlackChannel2FromJSON),
        
    };
}

export function SlackChannelsResponseToJSON(value?: SlackChannelsResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'channels': (value.channels as Array<any>).map(SlackChannel2ToJSON),
        
    };
}


